<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
  <base-v-component :heading="$t('dashboard')" :subtitle="greeting + ' ' + user.firstName" />

    <v-row class="mx-4">
      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="primary"
          icon="mdi-flask"
          :title="$t('ingredients')"
          :value="''+cosing.length"
          sub-icon="mdi-clock"
        /><!-- :sub-text="getCosingLastUpdated" -->
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="primary"
          icon="mdi-alert-circle-outline"
          :title="$t('restricted')"
          :value="''+restricted.length"
          sub-icon="mdi-tag"
          :sub-text="getLatestRestricted"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="primary"
          icon="mdi-alert"
          :title="$t('prohibited')"
          :value="''+prohibited.length"
          sub-icon="mdi-tag"
          :sub-text="getLatestProhibited"
        />
      </v-col>

      <v-col
        cols="12"
        sm="6"
        lg="3"
      >
        <base-material-stats-card
          color="primary"
          icon="mdi-check-bold"
          :title="$t('evaluations')"
          :value="''+evaluationCount"
          sub-icon="mdi-tag"
          :sub-text="getLatestProjectIngredient"
        />
      </v-col>
    </v-row>

  <v-row class="mx-4">

      <v-col cols="12" md="6">
        <base-material-card
          color="primary"
          icon="mdi-clipboard-outline"
          title="Product progress"
          class="px-5 py-3"
        >
          <apexchart 
            v-if="series.length"
            type="bar" 
            :options="chartOptions" 
            :series="series"
          />
          <v-subheader v-if="!series.length">No product status found</v-subheader>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="6">
        <base-material-card
          color="primary"
          icon="mdi-clock-outline"
          title="Upcoming delivery dates"
          class="px-5 py-3"
        >
        <v-subheader v-if="!productsByDelivery.length">No upcoming product delivery dates</v-subheader>
      <v-simple-table v-if="productsByDelivery.length">
        <thead>
          <tr>
            <th class="primary--text">
              Article
            </th>
            <th class="primary--text">
              Name
            </th>
            <th class="text-right primary--text">
              Delivery date
            </th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(item, index) in productsByDelivery"
            :key="index"
            @click="routeToProduct(item)"
          >
            <td>{{ item.productArticleNumber }}</td>
            <td>{{ item.productName }}</td>
            <td class="text-right">
              {{ $moment(item.deliveryDate).format('YYYY-MM-DD') }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
         </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'DashboardDashboard',

    data () {
      return {
        chartOptions: {
          colors: ['#c26bbb','#2EC4B6'],
          plotOptions: {
            bar: {
              horizontal: true,
              distributed: false,
              colors: {
                backgroundBarColors: ['#f2f2f2','#f2f2f2','#f2f2f2','#f2f2f2'],
                backgroundBarRadius: 0,
              },
            }
          },
          theme: {
            mode: 'light',
          },
          chart: {
            id: 'dashboard-product-status',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            categories: ['Completed', 'Documentation Ready', 'Waiting for Documentation', 'In Progress'],
            min: 0,
            max: 100,
            axisBorder: {
              show: false,
            },
            labels: {
              show: false,
            },
            axisTicks: {
              show: false,
            },
          },
          yaxis: {
            axisBorder: {
              show: false,
            },
          },
          grid: {
            show: false,
          },
          tooltip: {
            y: {
              formatter: function(value) {
               return value.toFixed(0) + '%'
              }
            }
          }
        },
        productsByDelivery: [],
        barColors: {
          dark: ['#282828','#282828','#282828','#282828'],
          light: ['#f2f2f2','#f2f2f2','#f2f2f2','#f2f2f2'],
        }
      }
    },

    created() {
      if (this.activeProject && this.activeProject.id) {
        this.fetchProductsByDeliveryDate(this.activeProject.id)
      }

      if (this.$vuetify.theme.dark) {
        this.chartOptions.theme.mode = 'dark';
        this.chartOptions.plotOptions.bar.colors.backgroundBarColors = this.barColors.dark;
        this.chartOptions.chart.background = '#1F1F1F';
      }
    },

    watch: {
      activeProject: function (newVal) {
        if (newVal.id) {
          this.fetchProductsByDeliveryDate(newVal.id);
        }
      }
    },

    computed: {
      user() {
        return this.$store.getters['user/getUser']
      },
      company() {
        return this.$store.getters['company/getCompany']
      },
      activeProject() {
        return this.$store.getters['projects/getActiveProject']
      },
      cosing() {
        return this.$store.getters["ingredients/getCosing"];
      },
      restricted() {
        return this.$store.getters["ingredients/getRestricted"];
      },
      prohibited() {
        return this.$store.getters["ingredients/getProhibited"];
      },
      projectIngredients() {
        return this.$store.getters["projectIngredients/getProjectIngredients"];
      },
      products() {
        return this.$store.getters["products/getProducts"];
      },
      /*
      productsByDelivery() {
        return this.$store.getters["products/getProductsByDelivery"];
      },
      */
      getCosingLastUpdated () {
        const item = this.cosing.reduce((a, b) => (a.updateDate > b.updateDate ? a : b));
        return item.updateDate;
      },
      getLatestProjectIngredient () {
        const item = this.getLatest(this.projectIngredients);
        return item  ? item.inciName  : 'No evaluation found';
      },
      getLatestRestricted () {
        const item = this.getLatest(this.restricted);
        return item ? item.inciName  : 'No data';
      },
      getLatestProhibited () {
        const item = this.getLatest(this.prohibited);
        return item ? item.innName  : 'No data';
      },
      greeting() {
        const currentTime = new Date().getHours();
        let msg = 'Good evening';
        if (currentTime<12) {
          msg = 'Good morning';
        } 
        else if (currentTime<17) {
          msg = 'Good afternoon'
        }
        return msg;
      },
      series() {
        if(this.company) {
          const arr = [];
          const status = this.company.productStatus;

          const status1 = status && status.COMPLETED>0 ? status.COMPLETED : 0;
          const status2 = status && status.DOCUMENTATION_READY>0 ? status.DOCUMENTATION_READY : 0;
          const status3 = status && status.WAITING_FOR_DOCUMENTATION>0 ? status.WAITING_FOR_DOCUMENTATION : 0;
          const status4 = status && status.IN_PROGRESS>0 ? status.IN_PROGRESS : 0;
          const tot = eval(status1 + status2 + status3 + status4);
          
          arr.push((status1/tot)*100 | 0);
          arr.push((status2/tot)*100 | 0);
          arr.push((status3/tot)*100 | 0);
          arr.push((status4/tot)*100 | 0);

          return [{
              name: 'Products',
              data: arr
            }];
        } else {
          return []
        }
      },
      evaluationCount() {
        const project = this.activeProject
        if (project && project.quantity && project.quantity.ingredients) {
          return project.quantity.ingredients;
        } else {
          return 0;
        }
      }
    },
    methods: {
      fetchProductsByDeliveryDate(projectId) {
        const limit = 5;
        if (projectId) {
          this.$store.dispatch('products/fetchProductsByDeliveryDate', { projectId, limit })
            .then((res) => {
              this.productsByDelivery = res;
            })
        }
      },
      complete (index) {
        this.list[index] = !this.list[index]
      },
      getLatest (data) {
        const list = JSON.parse(JSON.stringify(data))
        const arr = list.sort((a, b) => parseFloat(b.updateDate) - parseFloat(a.updateDate));
        return arr[0];
      },
      routeToProduct (item) {
        this.$router.push({ name: "products.edit", params: { id: item.id } });
      }
    },
  }
</script>

<style scoped>
</style>
